// extracted by mini-css-extract-plugin
export default {"detailsButton":"user-data-section_detailsButton__nkRoH","detailsButtonText":"user-data-section_detailsButtonText__fL+pD"};